module.exports = __webpack_public_path__ + "img/c15e481.svg";